import {
  DatasetTableConfig,
  crudActions,
  TableConfigBuilder,
  textColumn,
} from '@ui/lib/ui-kit/ui-dataset-table';
import { MonitoringModels } from '../../../monitoring/models/monitoring.models';
export function createContactsTableConfig(): DatasetTableConfig<MonitoringModels.OrganizationContact> {
  return new TableConfigBuilder<MonitoringModels.OrganizationContact>()
    .columns([
      textColumn<MonitoringModels.OrganizationContact>(
        'name',
        'MONITORING_PAGE.CONTACTS_TABLE.TITLES.NAME',
        {
          width: 'minmax(120px, 1fr)',
          mobileVisible: true,
        },
      ),
      textColumn<MonitoringModels.OrganizationContact>(
        'phones',
        'MONITORING_PAGE.CONTACTS_TABLE.TITLES.PHONE',
        {
          width: 'minmax(120px, 1fr)',
          mobileVisible: true,
        },
      ),
      textColumn<MonitoringModels.OrganizationContact>(
        'emails',
        'MONITORING_PAGE.CONTACTS_TABLE.TITLES.EMAIL',
        {
          width: 'minmax(120px, 1fr)',
          mobileVisible: true,
        },
      ),
    ])
    .actions(crudActions<MonitoringModels.OrganizationContact>())
    .trackBy('_id')
    .extend({
      responsive: {
        breakpoints: {
          card: 530,
        },
      }
    })
    .rowHeight(72)
    .build();
}
